import React from 'react';
import { Box, Card, Stack, Typography, Divider } from '@mui/material';

const MeetingAttendanceSummary = ({ summary }) => {
  if (!summary) return null;

  const stats = [
    { label: 'Toplam Katılımcı', value: summary.totalAttendances ?? 0 },
    { label: 'İzinli', value: summary.exemptCount ?? 0 },
    { label: 'Gelen', value: summary.attendedCount ?? 0 },
    { label: 'Gelmeyen', value: summary.absentCount ?? 0 },
    { label: 'Toplam Misafir', value: summary.totalGuests ?? 0 },
    { label: 'Gelen Misafir', value: summary.attendedGuestsCount ?? 0 },
    { label: 'Gelmeyen Misafir', value: summary.absentGuestsCount ?? 0 },
  ];

  const rates = [
    { label: 'Katılım Oranı', value: Number(summary.attendanceRate ?? 0).toFixed(1) },
    { label: 'Yoklama Oranı', value: Number(summary.absenceRate ?? 0).toFixed(1) },
  ];

  return (
    <Card
      sx={{
        p: 2.5,
        border: '1px solid #e7e7e7',
        boxShadow: 'none',
        borderRadius: '8px',
      }}
    >
      <Stack spacing={3}>
        <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 500, color: '#444444' }}>
          Katılım Özeti
        </Typography>
        
        {/* İstatistikler */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)', md: 'repeat(4, 1fr)', lg: 'repeat(7, 1fr)' },
            gap: 2,
          }}
        >
          {stats.map((stat, index) => (
            <Box key={index}>
              <Typography
                variant="body2"
                sx={{
                  fontSize: '13px',
                  color: '#666666',
                  fontWeight: 500,
                  mb: 0.5,
                }}
              >
                {stat.label}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: '24px',
                  fontWeight: 600,
                  color: '#444444',
                }}
              >
                {stat.value}
              </Typography>
            </Box>
          ))}
        </Box>

        <Divider sx={{ borderColor: '#e6e6e6' }} />

        {/* Oranlar */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
            gap: 2,
          }}
        >
          {rates.map((rate, index) => (
            <Box key={index}>
              <Typography
                variant="body2"
                sx={{
                  fontSize: '13px',
                  color: '#666666',
                  fontWeight: 500,
                  mb: 0.5,
                }}
              >
                {rate.label}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: '24px',
                  fontWeight: 600,
                  color: '#444444',
                }}
              >
                {rate.value}%
              </Typography>
            </Box>
          ))}
        </Box>
      </Stack>
    </Card>
  );
};

export default MeetingAttendanceSummary;
